const SERVICE_CONSTANTS = {
    EVENT_ADD_PAYMENT_INFO: "add_payment_info",
    EVENT_ADD_SHIPPING_INFO: "add_shipping_info",
    EVENT_ADD_TO_CART: "add_to_cart",
    EVENT_BEGIN_CHECKOUT: "begin_checkout",
    EVENT_PURCHASE: "purchase",
    EVENT_REMOVE_FROM_CART: "remove_from_cart",
    EVENT_SELECT_LIST_ITEM: "select_item",
    EVENT_VIEW_CART: "view_cart",
    EVENT_VIEW_ITEM: "view_item",
    EVENT_VIEW_ITEM_LIST: "view_item_list",
}

export default class TrackingService {
    constructor() { 
        this.options = Object.assign({}, this.options, SERVICE_CONSTANTS);
    }

    _mapItemProperties(item, dataLayerItem){
        dataLayerItem["item_id"]         = item.ProductCode;
        dataLayerItem["item_name"]       = item.ProductName; 
        dataLayerItem["item_brand"]      = "Raymond"; 
        dataLayerItem["item_category"]   = item.ProductCategory; 
        dataLayerItem["item_category2"]  = item.ProductSeries; 
        dataLayerItem["price"]           = item.PriceValue;
        // It's possible that the ProductCategory is not set, but the ProductSeries is
        // In that situation, move the ProductSeries value to item_category as the top-level category
        if(dataLayerItem["item_category"] == "" && dataLayerItem["item_category2"] != ""){
            dataLayerItem["item_category"]  = item.ProductSeries; 
            dataLayerItem["item_category2"] = ""; 
        }

    }

    _buildEcommerceItems(cartEntries){
        var dataItems = [];
        var listIndex = 0;

        if (!cartEntries) return dataItems;

        cartEntries.forEach(item => {
            if(item.Product.ProductQuantity == 0) return;
            // skip Accessory entry here, we will add via ProductReference
            if(item.IsProductAnAccessory) return;

            var dataItem = {
                index: listIndex,
                quantity: item.Product.ProductQuantity
            };

            this._mapItemProperties(item.Product, dataItem);

            dataItems.push(dataItem);
            listIndex++;

            if(item.Product.hasOwnProperty("ProductReference") && item.Product.ProductReference != null && item.Product.ProductReference.ProductName != null){
                var accessoryItem = {
                    index:      1,
                    quantity:   item.Product.ProductQuantity,
                    item_id:    item.Product.ProductReference.ProductCode,
                    item_name:  item.Product.ProductReference.ProductName,
                    item_brand: "Raymond",
                    price:      item.Product.ProductReference.PriceValue   
                };
                dataItems.push(accessoryItem);
                listIndex++;
            }
        });

        return dataItems;
    }

    _convertPrice(priceVal){
        if(priceVal == null || priceVal == "") return 0;
        if(Number.isInteger(priceVal)) return priceVal;
        return parseFloat(priceVal.replace(/[^0-9.]/g, ''));
    }
    
    /**
     * @method addPaymentInfo
     * @param {Object} cart current cart data
     */
     async addPaymentInfo(cart) {
        
        var dataItems = this._buildEcommerceItems(cart.Entries);
        
        var ecommerce = {
            currency:     "USD",
            value:        this._convertPrice(cart.SubTotal),
            payment_type: "Credit Card",
            items:        dataItems
        }

        var data = { event: this.options.EVENT_ADD_PAYMENT_INFO, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    
    /**
     * @method addShippingInfo
     * @param {Object} cart current cart data
     */
     async addShippingInfo(cart) {
        
        var dataItems = this._buildEcommerceItems(cart.Entries);
        
        var ecommerce = {
            currency:   "USD",
            value:      this._convertPrice(cart.SubTotal),
            items:      dataItems
        }

        var data = { event: this.options.EVENT_ADD_SHIPPING_INFO, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /**
     * @method addToCart
     * @param {Object} item item being added
     */
    async addToCart(item) {
        
        var dataItem = {
            index:      0,
            quantity:   item.ProductQuantity             
        };
        
        this._mapItemProperties(item, dataItem);
        var item_list = [dataItem];

        // Check for accessory reference
        var accessoryValue = 0;
        if(item.hasOwnProperty("ProductReference") && item.ProductReference && item.ProductReference.ProductName != null){
            var accessoryItem = {
                index:      1,
                quantity:   item.ProductQuantity,
                item_id:    item.ProductReference.ProductCode,
                item_name:  item.ProductReference.ProductName,
                item_brand: "Raymond",
                price:      item.ProductReference.PriceValue   
            };
            item_list.push(accessoryItem);
            accessoryValue = this._convertPrice(accessoryItem.price) * this._convertPrice(item.ProductQuantity);
        }
            
        var finalPrice = (this._convertPrice(item.PriceValue) * this._convertPrice(item.ProductQuantity)) + accessoryValue;

        var ecommerce = {
            currency:   "USD",
            value:      finalPrice,
            items:      item_list
        }
        
        var data = { event: this.options.EVENT_ADD_TO_CART, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(data);
        
        return;
    }

    /**
     * @method beginCheckout
     * @param {Object} cart current cart data
     */
    async beginCheckout(cart) {
        
        var dataItems = this._buildEcommerceItems(cart.Entries);
        
        var ecommerce = {
            currency:   "USD",
            value:      this._convertPrice(cart.SubTotal),
            items:      dataItems
        }

        var data = { event: this.options.EVENT_BEGIN_CHECKOUT, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /**
     * @method purchase
     * @param {Object} order order data
     */
     async purchase(order) {
        
        var dataItems = this._buildEcommerceItems(order.Entries);
        
        var ecommerce = {
            currency:        "USD",
            transaction_id:  order.OrderId,
            value:           this._convertPrice(order.TotalWithTax),
            shipping:        this._convertPrice(order.DeliveryTotal),
            tax:             this._convertPrice(order.TotalTax),
            items:           dataItems
        }

        var data = { event: this.options.EVENT_PURCHASE, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /**
     * @method removeFromCart
     * @param {Object} items items being removed
     */
    async removeFromCart(item) {
        
        var dataItem = {
            index:      0,
            quantity:   item.ProductQuantity             
        };
        
        this._mapItemProperties(item, dataItem);
        var item_list = [dataItem];

        // Check for accessory reference
        var accessoryValue = 0;
        if(item.hasOwnProperty("ProductReference") && item.ProductReference && item.ProductReference.ProductName != null){
            var accessoryItem = {
                index:      1,
                quantity:   item.ProductQuantity,
                item_id:    item.ProductReference.ProductCode,
                item_name:  item.ProductReference.ProductName,
                item_brand: "Lift-Rite",
                price:      item.ProductReference.PriceValue   
            };
            item_list.push(accessoryItem);
            accessoryValue = this._convertPrice(accessoryItem.price) * this._convertPrice(item.ProductQuantity);
        }
            
        var finalPrice = (this._convertPrice(item.PriceValue) * this._convertPrice(item.ProductQuantity)) + accessoryValue;

        var ecommerce = {
            currency:   "USD",
            value:      finalPrice,
            items:      item_list
        }

        var data = { event: this.options.EVENT_REMOVE_FROM_CART, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(data);
        
        return;
    }

    /**
     * @method removeFromCart
     * @param {Object} cart current cart data
     */
     async removeAllFromCart(cart) {
        
        var dataItems = this._buildEcommerceItems(cart.Entries);
        
        var ecommerce = {
            currency:   "USD",
            value:      this._convertPrice(cart.SubTotal),
            items:      dataItems
        }

        var data = { event: this.options.EVENT_REMOVE_FROM_CART, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(data);
        
        return;
    }

    /**
     * @method selectItem
     * @param {string} list_id id of list where selection was made
     * @param {string} list_name name of list where selection was made
     * @param {Object} item selected item
     */
    async selectItem(list_id, list_name, item) {

        var dataItem = {
            index: 0
        };

        this._mapItemProperties(item, dataItem);

        var ecommerceObject = {
            item_list_id: list_id,
            item_list_name: list_name,
            items: [dataItem]
        }

        var data = { event: this.options.EVENT_SELECT_LIST_ITEM, ecommerce : ecommerceObject };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data);

        return;
    }

    /**
     * @method viewItem
     * @param {Object} item viewed item
     */
    async viewItem(item) {
        var dataItem = {
            index:      0
        };

        this._mapItemProperties(item, dataItem);

        var ecommerce = {
            currency:   "USD",
            value:      item.PriceValue, 
            items:      [dataItem]
        }

        var data = { event: this.options.EVENT_VIEW_ITEM, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /**
     * @method viewItemList
     * @param {String} list_id id of viewed list 
     * @param {String} list_name name of viewed list
     * @param {[Object]} items list items
     */
     async viewItemList(item_list_id, item_list_name, items) {            
        
        var dataItems = [];
        var listIndex = 0;

        items.forEach(item => {
            var dataItem = {
                index: listIndex
            };

            this._mapItemProperties(item, dataItem);

            dataItems.push(dataItem);
            listIndex++;
        });
        
        var ecommerce = {
            item_list_id: item_list_id,
            item_list_name: item_list_name,
            items: dataItems
        }

        var data = { event: this.options.EVENT_VIEW_ITEM_LIST, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /**
     * @method viewCart
     * @param {Object} cart current cart data
     */
    async viewCart(cart) {
        
        var dataItems = this._buildEcommerceItems(cart.Entries);
        
        var ecommerce = {
            currency:   "USD",
            value:      this._convertPrice(cart.SubTotal),
            items:      dataItems
        }

        var data = { event: this.options.EVENT_VIEW_CART, ecommerce : ecommerce };

        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push(data); 
        return;
    }

    /***
     * GOOGLE ADS
     */

    /**
     * @method purchase
     * @param {Object} order order data
     */
     async adsConversion(order, property) {

        var config = {
            send_to:         property,
            value:           this._convertPrice(order.TotalWithTax),
            currency:        "USD",
            transaction_id:  order.OrderId
        }

        window.dataLayer.push({ ecommerce: null }); 
        gtag("event", "conversion", config);
        return;
    }

}